import React from 'react';
import _ from 'underscore';

import TFIActions from 'notebook/tfi/TFIActions';
import {AccountType, TFIAccount, TFIFolder} from 'notebook/tfi/TFIConstants';
import TFIUtil from 'notebook/tfi/TFIUtil';
import PlainSearchInput, {ClearType} from 'ui-library/PlainSearchInput';
import {listToReadable} from 'util/NameUtil';
import {InputChangeEvent} from 'util/Types';

export interface TFISearchInputProps {
  accounts?: Array<TFIAccount> | null;
  listedFolder?: TFIFolder | null;
  onSearchInputReceivedFocus: () => void;
  query?: string | null;
  searchInputPendingFocus: boolean;
}

export default class TFISearchInput extends React.Component<TFISearchInputProps> {
  plainSearchInputRef = React.createRef<PlainSearchInput>();

  override componentDidMount(): void {
    this.handleSearchInputPendingFocus();
  }

  override componentDidUpdate(): void {
    this.handleSearchInputPendingFocus();
  }

  private handleSearch = (e: InputChangeEvent): void => {
    TFIActions.setTFIAccountFilter(this.props.listedFolder ? this.props.listedFolder.accountId : null);
    TFIActions.setQuery(e.target.value);
  };

  private handleClearSearch = (): void => {
    TFIActions.clearSearch();
  };

  private handleSearchInputPendingFocus = (): void => {
    if (this.props.searchInputPendingFocus) {
      this.plainSearchInputRef.current!.focus();
      this.props.onSearchInputReceivedFocus();
    }
  };

  override render(): JSX.Element {
    let accountTypes: Array<AccountType>;
    if (this.props.listedFolder) {
      accountTypes = [this.props.listedFolder.accountType];
    } else if (this.props.accounts) {
      accountTypes = this.props.accounts.map((account) => account.accountType);
    } else {
      accountTypes = [];
    }
    const searchText = accountTypes.length
      ? // eslint-disable-next-line no-restricted-syntax
        listToReadable(_.uniq(accountTypes).map((accountType) => TFIUtil.readableAccountType(accountType)))
      : 'external files';
    return (
      <div className="tfi-searchInput">
        <PlainSearchInput
          className="u-width-full"
          clearType={ClearType.CANCEL}
          value={this.props.query}
          onChange={this.handleSearch}
          onEscape={this.handleClearSearch}
          placeholder={`Search ${searchText}`}
          ref={this.plainSearchInputRef}
        />
      </div>
    );
  }
}
